import AppHeader from '../AppHeader'
import SubMenu from '../SubMenu'
import $ from 'jquery'
global.jQuery = $
window.jQuery = $

export default {
  name: 'propose-rejected-detail',
  created () {
    this.search()
  },
  data () {
    return {
      callbackflg: false
    }
  },
  computed: {
    proposeDetail () {
      return this.$store.getters.proposeDetail
    },
    joint1User () {
      return this.$store.getters.joint1User
    },
    joint2User () {
      return this.$store.getters.joint2User
    },
    profileImagePath () {
      return this.proposeDetail.attributes['profile-image-path'] ? this.proposeDetail.attributes['profile-image-path'] : ''
    },
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    timeStamp () {
      const d = new Date()
      const year = d.getFullYear()
      const month = d.getMonth() + 1
      const day = d.getDate()
      const hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      const min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      const sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    }
  },
  components: {
    AppHeader,
    SubMenu
  },
  methods: {
    search: function () {
      const self = this
      const data = {}
      const callback = function () {
        self.callbackflg = true
        self.$store.dispatch('PROPOSE_UPDATE_ON_ALREADY_READ', {id: self.$route.params.id})
      }
      this.$store.dispatch('PROPOSE_DETAIL', {id: this.$route.params.id, data: data, callback: callback})
    },
    content: function (word) {
      return word ? word.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\r?\n/g, '<br>') : ''
    },
    goProfileDetail: function (userId) {
      window.sessionStorage.setItem('profile_detail_referrer', this.$router.history.current.path)
      this.$router.push('/profile/' + userId)
    },
    goBack: function () {
      this.$router.push({ path: '/propose_rejected_list' })
    },
    goProposeEdit: function (proposeId) {
      this.$router.push({path: '/propose/' + proposeId + '/edit'})
    },
    onDeleted: function (result) {
      const button = document.getElementById('proposeDeletedModalButton')
      button.click() // モーダル表示 イベント発火
    },
    goProposeDelete: function (proposeId) {
      this.$store.dispatch('PROPOSE_DELETE', {id: proposeId, callback: this.onDeleted})
    },
    goProposeRejectedList: function () {
      this.$router.push({ path: '/propose_rejected_list' })
      window.location.reload(false)
    },
    onModalClose: function () {
      $('#proposeDeletedModal').modal('hide')
      this.goProposeRejectedList()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/propose-rejected-detail.js